var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorbug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4899_25878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 71.9999C55.882 71.9999 71.9997 55.8822 71.9997 35.9998C71.9999 16.1177 55.8822 0 35.9999 0C16.1177 0 0 16.1177 0 36.0001C0 55.8824 16.1177 71.9999 35.9999 71.9999Z",
    fill: "#FF6465"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.68511 36.0001C9.68511 17.7602 23.2506 2.69085 40.8425 0.325265C39.2583 0.112219 37.6424 0 35.9999 0C16.1177 0 0 16.1177 0 36.0001C0 55.8824 16.1177 72 35.9998 72C37.6423 72 39.2582 71.8878 40.8423 71.6747C23.2506 69.309 9.68511 54.2397 9.68511 36.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.069 36.0005L53.5468 26.5227C54.2358 25.8338 54.2358 24.7168 53.5468 24.028L47.9711 18.4522C47.2822 17.7633 46.1652 17.7633 45.4764 18.4522L35.9986 27.9301L26.5207 18.4522C25.8318 17.7633 24.7148 17.7633 24.0261 18.4522L18.4503 24.028C17.7614 24.7169 17.7614 25.8339 18.4503 26.5227L27.9281 36.0005L18.4503 45.4783C17.7614 46.1673 17.7614 47.2842 18.4503 47.9732L24.0261 53.5489C24.715 54.2379 25.832 54.2379 26.5207 53.5489L35.9986 44.0711L45.4765 53.5489C46.1654 54.2379 47.2824 54.2379 47.9712 53.5489L53.547 47.9732C54.2359 47.2842 54.2359 46.1673 53.547 45.4783L44.069 36.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4899_25878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorbug);
export default __webpack_public_path__ + "static/media/errorbug.8e3b5c19eaa6a40b3eb387576cc48aad.svg";
export { ForwardRef as ReactComponent };